class KretoPurchaseOptions {
  constructor(root) {
    this.root = root;
    this.planInput = root.querySelector('[data-kreto-selling-plan]');
    this.planSelect = root.querySelector('[data-kreto-plan-select]');
    this.frequency = root.querySelector('.kreto-purchase__frequency');
    this.radios = root.querySelectorAll('input[type="radio"]');
    this.radios.forEach((radio) => radio.addEventListener('change', () => this.update()));
    this.planSelect?.addEventListener('change', () => {
      this.planInput.value = this.planSelect.value;
      this.updateSubscriptionPrice();
    });
    this.sectionId = root.closest('product-info')?.dataset.section;
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      this.unsubscribeVariantChange = subscribe(
        PUB_SUB_EVENTS.variantChange,
        this.handleVariantChange.bind(this)
      );
    }
    this.update();
  }

  updateSubscriptionPrice() {
    const price = this.planSelect?.selectedOptions?.[0]?.dataset.price;
    const priceNode = this.root.querySelector('[data-kreto-subscription-price]');
    if (price && priceNode) priceNode.textContent = price;
  }

  handleVariantChange({ data }) {
    if (data.sectionId !== this.sectionId) return;

    const sourceRoot = data.html.querySelector('[data-kreto-purchase]');
    if (!sourceRoot) return;

    const sourceOneTimePrice = sourceRoot.querySelector('[data-kreto-one-time-price]');
    const oneTimePrice = this.root.querySelector('[data-kreto-one-time-price]');
    if (sourceOneTimePrice && oneTimePrice) {
      oneTimePrice.textContent = sourceOneTimePrice.textContent;
    }

    if (this.planSelect) {
      this.planSelect.querySelectorAll('option').forEach((option) => {
        const sourceOption = sourceRoot.querySelector(
          `[data-kreto-plan-select] option[value="${CSS.escape(option.value)}"]`
        );
        if (sourceOption?.dataset.price) option.dataset.price = sourceOption.dataset.price;
      });
    }

    this.updateSubscriptionPrice();
  }

  update() {
    if (!this.planInput) return;
    const subscribe = this.root.querySelector('input[value="subscribe"]')?.checked;
    this.planInput.disabled = !subscribe;
    if (subscribe && this.planSelect) this.planInput.value = this.planSelect.value;
    if (this.frequency) this.frequency.hidden = !subscribe;
    this.updateSubscriptionPrice();
  }
}

const initKretoPurchaseOptions = (scope = document) => {
  scope.querySelectorAll('[data-kreto-purchase]').forEach((root) => {
    if (!root.dataset.initialized) {
      root.dataset.initialized = 'true';
      new KretoPurchaseOptions(root);
    }
  });
};

document.addEventListener('DOMContentLoaded', () => initKretoPurchaseOptions());
document.addEventListener('shopify:section:load', (event) => initKretoPurchaseOptions(event.target));
